<template>
  <div class="search__nav">
    <div class="search__nav__title">
      <div class="search__nav__tags">
        <span>当前搜索：</span>
        <span v-if="searchText" style="margin-right:12px">{{ `"${searchText}"` }}</span>
        <SearchTag v-for="item in searchClass" :tab="item" :key="item.content" @close="handleCloseTag" />
      </div>
      <div class="search__nav__classify">
        <div v-if="search.itemAggFactoryNames && search.itemAggFactoryNames.length" class="search__nav__classify__row">
          <div class="search__nav__classify__row__title">厂家</div>
          <div class="search__nav__classify__row__content">
            <ShowMore :key="search.itemAggFactoryNames.length">
              <div
                v-for="factory in search.itemAggFactoryNames"
                :key="factory"
                :class="{
                  search__nav__classify__row__content__item: true,
                  pointer: true,
                  active: factory == chooseFactoryValue
                }"
                @click="chooseFactory(factory)"
              >
                {{ factory }}
              </div>
            </ShowMore>
          </div>
        </div>
        <div v-if="search.specsAgg && search.specsAgg.length" class="search__nav__classify__row">
          <div class="search__nav__classify__row__title">规格</div>
          <div class="search__nav__classify__row__content">
            <ShowMore :key="search.specsAgg.length" @edit="handleEditSpec">
              <div
                v-for="spec in search.specsAgg"
                :key="spec"
                :class="{
                  search__nav__classify__row__content__item: true,
                  pointer: true,
                  active: chooseSpecValue.includes(spec)
                }"
                @click="chooseSpec(spec)"
              >
                {{ spec }}
              </div>
            </ShowMore>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SearchTag from './SearchTag';
import ShowMore from './ShowMore';
import { cloneDeep } from 'lodash';

export default {
  props: {
    search: {
      type: Object,
      default: () => {
        return {
          itemAggFactoryNames: [],
          specsAgg: [],
          merchantAggInfos: []
        };
      }
    }
  },
  components: {
    SearchTag,
    ShowMore
  },
  computed: {
    searchText() {
      return this.$route.query.text || '';
    }
  },
  watch: {
    $route: {
      handler({ query: { title, content, code } }) {
        this.resetSearchClass();
        if (title && content && code) {
          this.autoSelectCategory(title, content, code);
        }
      },
      immediate: true,
      deep: true
    }
  },
  data() {
    return {
      searchClass: [],
      chooseFactoryValue: null,
      chooseSpecValue: [],
      editSpec: false,
      chooseCategoryCode: null
    };
  },
  methods: {
    addSearchClass(cls) {
      this.searchClass.push(cls);
    },
    delSearchClass(index) {
      this.searchClass.splice(index, 1);
    },
    updatesearchClass({ index, content }) {
      this.searchClass[index].content = content;
    },
    resetSearchClass() {
      this.searchClass = [];
    },
    chooseFactory(factory) {
      if (this.chooseFactoryValue == factory) return;
      this.chooseFactoryValue = factory;
      this.autoSelectCategory('厂家', factory, factory);
      this.searchChange();
    },
    chooseSpec(spec) {
      let copy = cloneDeep(this.chooseSpecValue);
      if (copy.indexOf(spec) > -1) {
        const existIndex = copy.indexOf(spec);
        if (existIndex > -1) {
          copy.splice(existIndex, 1);
        }
        let delIndex = -1;
        this.searchClass.map((item, index) => {
          if (item.content === spec) delIndex = index;
        });
        this.searchClass.splice(delIndex, 1);
      } else {
        if (this.chooseSpecValue.length >= 10) {
          this.$message.warning('最多只能选择10个规格筛选');
          return;
        }
        copy.push(spec);
      }
      this.chooseSpecValue = copy;
      this.chooseSpecValue.forEach(ele => {
        this.autoSelectCategory('规格', ele, ele, true);
      });
      this.searchChange();
    },
    resetSpec() {
      this.chooseSpecValue = [];
    },

    handleEditSpec() {
      this.editSpec = true;
    },
    searchChange(firstFlag) {
      let emitName;
      emitName = firstFlag ? 'first-change' : 'change';
      this.$emit(emitName, {
        chooseFactoryValue: this.chooseFactoryValue,
        chooseSpecValue: this.chooseSpecValue,
        chooseCategoryCode: this.chooseCategoryCode
      });
    },
    init() {
      this.searchClass.forEach(ele => {
        if (ele.title == '厂家') {
          this.chooseFactoryValue = ele.value;
        } else if (ele.title == '规格') {
          this.chooseSpecValue.push(ele.value);
        } else if (ele.title == '分类') {
          this.chooseCategoryCode = ele.value;
        }
      });
      this.searchChange(true);
    },
    handleCloseTag({ title, content }) {
      let index = this.findIndex(this.searchClass, title, 'title');
      if (index !== -1) {
        this.delSearchClass(index, 1);
      }
      if (title == '厂家') {
        this.chooseFactoryValue = null;
      } else if (title == '规格') {
        this.chooseSpec(content);
      } else if (title == '分类') {
        this.chooseCategoryCode = null;
      }
      this.searchChange();
    },
    findIndex(arr, ele, key) {
      let length = arr.length;
      if (!length) return -1;
      let flag = -1;
      for (let i = 0; i < length; i++) {
        if (key && arr[i][key] == ele) {
          flag = i;
        } else if (arr[i] == ele) {
          flag = i;
        }
      }
      return flag;
    },
    autoSelectCategory(title, content, value, multiple = false) {
      let index = this.findIndex(this.searchClass, title, 'title');
      if (index !== -1 && !multiple) {
        let flag = this.findIndex(this.searchClass, content, 'content');
        if (flag !== -1) {
          this.delSearchClass.splice(flag, 1);
        } else {
          this.updatesearchClass({ index, content, value });
        }
      } else {
        let flag = this.findIndex(this.searchClass, content, 'content');
        if (flag == -1) {
          this.addSearchClass({
            title,
            content,
            value
          });
        }
      }
    }
  },
  created() {
    this.init();
  },
  destroyed() {
    this.resetSearchClass();
  }
};
</script>

<style lang="scss" scoped>
@import '@/style/mixin.scss';
.search__nav {
  padding-top: 12px;
  &__title {
    font-size: 12px;
    font-weight: 400;
    color: #595959;
    line-height: 1;
  }
  &__tags {
    display: flex;
    min-height: 28px;
    align-items: center;
    flex-wrap: wrap;
  }
  &__classify {
    display: table;
    border-collapse: collapse;
    width: 100%;
    margin-top: 12px;
    &__row {
      display: table-row;
      &__title,
      &__content {
        display: table-cell;
        border: 1px solid #eeeeee;
      }
      &__title {
        width: 100px;
        padding: 18px 16px;
        font-size: 12px;
        font-weight: 500;
        color: #595959;
        line-height: 1;
      }
      &__content {
        padding: 10px 12px 10px 0;
        font-size: 12px;
        font-weight: 400;
        color: #595959;
        line-height: 1;
        background: #ffffff;
        &__item {
          display: inline-block;
          padding: 0 12px;
          height: 32px;
          line-height: 32px;
        }
      }
    }
  }
  .active {
    color: #d96900;
  }
  ::v-deep .el-checkbox__label {
    font-size: 12px;
    font-weight: 400;
    color: #595959;
  }
  /deep/ .el-checkbox {
    margin-right: 24px;
    margin-bottom: 14px;
  }
}
</style>
